import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { MessageSquareText, FileText } from "lucide-react";
import { downloadAttachment } from "@/lib/files";

// Notes and meeting summaries a staff member explicitly shared with this Person (server-filtered).
export function SharedWithYou() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/portal/shared-notes").then((r) => setItems(r.data.items || [])).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 mb-4" data-testid="portal-shared-notes">
      <p className="font-semibold text-slate-800 flex items-center gap-2 mb-2"><MessageSquareText className="w-4 h-4 text-brand" />Shared with you</p>
      <ul className="space-y-2">{items.map((n) => (
        <li key={n.id} className="text-sm text-slate-700 border-t border-slate-100 pt-2 first:border-0 first:pt-0" data-testid={`portal-shared-${n.id}`}>
          {n.kind === "document" ? <button className="inline-flex items-center gap-1.5 text-brand hover:underline" data-testid={`portal-shared-doc-${n.id}`}
              onClick={() => downloadAttachment(`/portal/attachments/${n.id}/file`, n.original_filename)}><FileText className="w-4 h-4" />{n.original_filename}</button>
          : n.kind === "email" ? <><b>{n.subject || "(no subject)"}</b> <span className="text-xs text-slate-400">{new Date(n.sent_at || n.received_at).toLocaleDateString()}</span>
            <iframe title={n.subject || "email"} sandbox="" srcDoc={n.bodyhtml || ""} className="w-full min-h-[160px] border-0 bg-white" data-testid={`portal-shared-email-${n.id}`} /></>
          : n.kind === "meeting_summary" ? <><b>{n.title}</b> <span className="text-xs text-slate-400">{n.meeting_date}</span>
            <iframe title={n.title || "summary"} sandbox="" srcDoc={n.notes_html || ""} className="w-full min-h-[120px] border-0 bg-white" /></>
            : <><p className="whitespace-pre-wrap">{n.text}</p><span className="text-xs text-slate-400">{n.author_name} · {new Date(n.created_at).toLocaleDateString()}</span></>}
        </li>))}</ul>
    </div>
  );
}
